import { createSvgIcon } from '@mui/material/utils'

const DeletePlate = createSvgIcon(
  <>
    <path
      d="M37.0399 46.59C32.2199 33.31 25.2699 23.01 15.7299 27.89C-2.48011 37.21 29.5599 77.88 42.5599 10.29"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M55.9199 53.78C56.8199 51.01 58.0199 47.91 59.6199 44.47C65.4399 31.89 67.1699 26.32 67.6499 23.9"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M45.5646 4.37792C45.8025 2.37061 45.0973 0.636911 43.9894 0.505591C42.8816 0.374271 41.7906 1.89506 41.5526 3.90237C41.3147 5.90968 42.0199 7.64338 43.1278 7.7747C44.2356 7.90602 45.3266 6.38523 45.5646 4.37792Z"
      fill="#204ECF"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M53.5701 5.32586C53.6826 4.37705 51.6797 3.35966 49.0965 3.05347C46.5133 2.74727 44.3281 3.26821 44.2156 4.21702C44.1031 5.16583 46.106 6.18322 48.6892 6.48942C51.2724 6.79561 53.4576 6.27467 53.5701 5.32586Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M43.5589 4.1361C43.6714 3.18729 41.6684 2.16991 39.0853 1.86371C36.5021 1.55752 34.3168 2.07846 34.2044 3.02727C34.0919 3.97608 36.0948 4.99346 38.678 5.29966C41.2612 5.60585 43.4464 5.08491 43.5589 4.1361Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M67.965 21.695C68.7921 21.5221 69.2088 20.168 68.8956 18.6705C68.5825 17.1731 67.6582 16.0994 66.8311 16.2723C66.004 16.4453 65.5873 17.7994 65.9004 19.2968C66.2135 20.7943 67.1379 21.868 67.965 21.695Z"
      fill="#204ECF"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M71.6618 19.4369C73.5917 19.0334 75.0361 18.1322 74.8881 17.424C74.74 16.7158 73.0555 16.4688 71.1255 16.8724C69.1956 17.2759 67.7511 18.1771 67.8992 18.8853C68.0473 19.5935 69.7318 19.8404 71.6618 19.4369Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M64.1793 20.9948C66.1093 20.5912 67.5537 19.69 67.4057 18.9818C67.2576 18.2737 65.573 18.0267 63.6431 18.4302C61.7132 18.8338 60.2687 19.735 60.4168 20.4432C60.5649 21.1513 62.2494 21.3983 64.1793 20.9948Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M89.3 65.74L0.5 66.29C0.5 71.46 4.69 73.45 9.86 73.45H79.94C85.11 73.45 89.3 71.45 89.3 66.29V65.74V65.74Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M25.72 66.08L28.51 58.5L40.51 52.33C41.29 53.64 42.93 56.03 45.89 57.98C48.72 59.84 53.49 61.75 54.98 61.96V66.08"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M60.27 66.08L62.31 61.96L65.65 62.84H68.99L70.45 66.08"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M65.6499 62.84V66.08" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M40.4199 65.68L39.7 60.39L40.5 52.33" stroke="#204ECF" strokeLinejoin="round" />
  </>,
  'DeletePlate'
)

export default DeletePlate
